// ----------------------------------------------------------------------

// SI CETTE TRADUCTION EST INCORRECTE, VEUILLEZ L'IGNORER CAR CETTE TRADUCTION EST UNIQUEMENT À DES FINS DE DÉMO
// Nous sommes heureux si vous pouvez aider à améliorer la traduction en envoyant un e-mail à support@minimals.cc.

// ----------------------------------------------------------------------

const fr = {
  lorem_ipsum:
    'Lorem ipsum dolor sit ametLorem ipsum dolor sit amet, consectetur adipiscing elit. A, ut ipsum lectus purus.Lorem ipsum dolor sit amet, consectetur adipiscing elit. A, ut ipsum lectus purus. ',
  dont_have_an_account: "Vous n'avez pas de compte ?",
  setup_group_properties:
    'Configurer des groupes et des propriétés dans HubSpot',
  woocommer_setup_hubspot:
    'Pour afficher correctement vos données BigCommerce dans HubSpot, vous devez configurer des groupes et des propriétés dans votre compte HubSpot.',
  go_to_sync_now: 'Go to Sync Now',
  start_date: 'Start Date',
  end_date: 'End Date',
  products: 'des produits',
  sync_selected_data_row: 'Synchroniser la ligne de données sélectionnée',
  import_data: 'Import Data',
  import_export: 'Importer/Exporter',
  import_line_1:
    '* Les actions peuvent être utilisées pour transférer toutes vos données BigCommerce vers votre compte HubSpot. Cette action synchronisera les détails des produits, des clients, des commandes et des éléments de ligne.',
  import_line_2:
    '* Pour télécharger les détails de BigCommerce vers HubSpot, veuillez importer vos données de BigCommerce vers l\'application en cliquant sur "Importer des données".',
  import_line_3:
    '* Une fois le processus d\'importation des données terminé, vous pouvez télécharger des données sur HubSpot en cliquant sur "Télécharger des données". Il serait préférable de télécharger des données en plus petits morceaux en utilisant le filtre de plage de dates.',
  import_line_4:
    '* Si vous avez des inquiétudes concernant la synchronisation des données, veuillez contacter le support MakeWebBetter.',
  from_bigcommerce_to_app: "Du BigCommerce à l'application",
  select_data_type: 'Sélectionnez le type de données',
  select: 'sélectionner',
  set_date_range: 'Définir la plage de dates : ',
  from_app_to_hubspot: "De l'application à HubSpot",
  settings: 'réglages',
  setup_line_1:
    'Pour afficher correctement vos données BigCommerce dans HubSpot, vous devez configurer des groupes et des propriétés dans votre compte HubSpot.',
  setup_line_2:
    'Une fois que vous avez configuré des groupes et des propriétés, vous pouvez facilement voir les informations suivantes sur vos contacts et clients :',
  setup_line_3:
    'La création de groupe et de propriété est en cours. Cela ne devrait prendre que quelques instants. Merci pour votre patience!',
  setup_line_4:
    'Configurez des listes pour segmenter vos contacts et clients en fonction de leurs actions et comportements antérieurs.',
  order_information: 'Informations sur la commande',
  previous_purchase: 'Achats précédents',
  abandoned_cart_details: 'Détails du panier abandonné',
  and_more: 'Et plus',
  leads_contact: " Leads : contacts qui n'ont pas encore passé de commande",
  customer_contact: ' Clients : contacts ayant passé au moins une commande',
  create_lists_in_hubspot: 'Créer des listes dans HubSpot',
  create_workflows_bigcommerce: 'Créer des flux de travail dans BigCommerce',
  abandoned_cart_contacts:
    " Panier abandonné : contacts qui ont ajouté des produits à leur panier, mais qui n'ont pas acheté",
  create_list: 'Créer des listes',
  create_workflows: 'Créer des flux de travail',
  map_deals_stages_with_hubspot_pipline:
    'Cartographier les étapes de la transaction avec le pipeline HubSpot',
  map_deals_line_1:
    'Synchronisez les statuts des commandes avec les étapes de la transaction afin de pouvoir gérer votre pipeline de commerce électronique dans HubSpot',
  map_deals_line_2:
    'Une fois que vous avez configuré des groupes et des propriétés, vous pouvez facilement voir les informations suivantes sur vos contacts et clients :',
  pending_payment: 'En attente de paiement',
  save: 'sauvegarder',
  reset_to_default_mapping: 'Réinitialiser le mappage par défaut',
  set_date_range_to_sync: 'Définir la plage de dates sur synchroniser',
  all_the_data_is_successfully_synced:
    'Toutes les données sont synchronisées avec succès.',
  close_this_window_to_see_updated_data_tables:
    'Fermez cette fenêtre pour voir les tables de données mises à jour.',
  sync_successfull: 'Synchronisation réussie',
  you_can_see_your_sync_progress_in_the_activity_tab:
    "Vous pouvez voir la progression de votre synchronisation dans l'onglet Activité.",
  to: 'À',
  lists: 'Listes',
  status: 'Statut',
  create: 'Créer',
  created: 'Établie',
  leads: 'Pistes',
  customer: 'Clientes',
  new_customer: 'nouveaux clients',
  abandon_cart: 'Abandonner le panier',
  best_customer: 'Meilleurs clients',
  big_spendors: 'Gros dépensiers',
  low_value_customer: 'Clients à faible valeur',
  about_to_sleep: 'Sur le point de dormir',
  lists_line_1:
    "Les listes sont des listes HubSpot qui se mettent à jour automatiquement, en inscrivant les contacts qui répondent aux critères d'adhésion et en supprimant ceux qui n'y répondent plus.",
  lists_line_2:
    'Il est conçu pour obtenir un prospect qualifié pour effectuer le premier achat.',
  workflow: 'flux de travail',
  workflow_line_1:
    "Les workflows sont des listes HubSpot qui se mettent à jour automatiquement, en inscrivant les contacts qui répondent aux critères d'adhésion et en supprimant ceux qui n'y répondent plus.",
  workflow_details: 'Détails du flux de travail',
  groups_and_properties: 'Groupes et propriétés',
  groups_properties_line_1:
    "Les groupes et les propriétés sont utilisés pour stocker des données sur certains objets dans HubSpot, tels que les contacts, les entreprises, les offres et les tickets. Vous pouvez avoir jusqu'à 1 000 propriétés par objet, y compris les propriétés HubSpot par défaut.",
  hubspot_data_logs: 'Journaux de données HubSpot',
  apply: 'appliquer',
  include_resolved_error: "Inclure l'erreur résolue:",
  error_type: "Type d'erreur:",
  object_type: "Type d'objet:",
  limit: 'limite',
  please_enter: 'Veuillez entrer entre 1 et 200',
  note: "Remarque : les journaux HubSpot peuvent s'habituer à filtrer les erreurs/avertissements HubSpot survenus lors de la synchronisation des données.",
  logs_detail: 'Détail des journaux',
  yes_take_me_to_hubspot: 'Oui, emmenez-moi sur HubSpot',
  cancel: 'Annuler',
  saved_mapping_data: 'Données cartographiques enregistrées',
  import: 'Importer',
  export: 'Exporter',
  view_in_hubspot: 'Voir dans Hubspot',
  select_atleast_one_product_to_export:
    'Sélectionnez au moins un produit à exporters',
  no_activities_found: 'Aucune activité trouvée',
  sync_in_progress: 'Synchronisation en cours',
};

export default fr;
